
const filtroBusquedaSEState = {
  loading: null,
  loadingFile: false,
  loadingSolicitudes: false,
  loadingErrores: false,
  tiposAtencion: [],
  filtros: {
    tipoAtencion: "",
  },
  prestaciones: [],
  solicitudes: [],
  errores: [],
  detalleSolicitud: null,
  sizeArchivo: [],
};

export default filtroBusquedaSEState;




// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/FiltroBusqueda/state.js